import request from '@/utils/request';

//新建礼品
export const editManagementGiftForm = (data, callback) => {
  return request('/activityPoints/addGift', {
    method: 'POST',
    data,
  }).catch(() => {
    callback();
  });
};
//编辑礼品
export const updateGift = (data, callback) => {
  return request('/activityPoints/updateGift', {
    method: 'POST',
    data,
  }).catch(() => {
    callback();
  });
};

//查询礼品详情
export const getQueryGiftDetail = (data) => {
  return request('/activityPoints/queryGiftDetail', {
    method: 'POST',
    data,
  });
};
